import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ToolTipIcon from './toolTipIcon'

import './toolTip.sass'

export default class ToolTip extends React.Component {
  icon = React.createRef()

  static propTypes = {
    children: PropTypes.node,
    image: PropTypes.string,
  }

  static defaultProps = {
    children: null,
    image: null,
  }

  state = {
    isOpen: false,
  }

  componentDidMount = () => {
    document.addEventListener('click', this.handleClickPage)
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleClickPage)
  }

  handleOpen = () => {
    this.setState({ isOpen: true })
  }

  handleClickPage = e => {
    if (e.target !== this.icon.current) this.setState({ isOpen: false })
  }

  render() {
    return (
      <div
        className={classNames('tooltip', {
          'is-open': this.state.isOpen,
        })}
      >
        <ToolTipIcon isActive={this.state.isOpen} onClick={this.handleOpen} inputRef={this.icon} />
        <div className="tooltip-content">
          {this.props.image && <img className="tooltip-image" src={this.props.image} alt="tip" />}
          {this.props.children}
        </div>
      </div>
    )
  }
}
